import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { HeroLP1 } from '../components/HeroLP1';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPageLP1() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1308">
      <PriceAlert data-id="element-1309" />
      <HeroLP1 data-id="element-1310" />
      <Testimonial data-id="element-1311" />
      <ProblemSolution data-id="element-1312" />
      <ValueStack data-id="element-1313" />
      <ModuleBreakdown data-id="element-1314" />
      <Guarantee data-id="element-1315" />
      <PricingSection data-id="element-1316" />
      <Footer data-id="element-1317" />
      <RecentPurchaseToast data-id="element-1318" />
    </div>;
}